import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import Vue from 'vue';
import "./import-quasar.js";
import App from 'app/src/App.vue';
import createStore from 'app/src/store/index';
import createRouter from 'app/src/router/index';
export default function () {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var store, router, app;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof createStore === 'function')) {
            _context.next = 6;
            break;
          }
          _context.next = 3;
          return createStore({
            Vue: Vue
          });
        case 3:
          _context.t0 = _context.sent;
          _context.next = 7;
          break;
        case 6:
          _context.t0 = createStore;
        case 7:
          store = _context.t0;
          if (!(typeof createRouter === 'function')) {
            _context.next = 14;
            break;
          }
          _context.next = 11;
          return createRouter({
            Vue: Vue,
            store: store
          });
        case 11:
          _context.t1 = _context.sent;
          _context.next = 15;
          break;
        case 14:
          _context.t1 = createRouter;
        case 15:
          router = _context.t1;
          // make router instance available in store
          store.$router = router;

          // Create the app instantiation Object.
          // Here we inject the router, store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = {
            router: router,
            store: store,
            render: function render(h) {
              return h(App);
            }
          };
          app.el = '#q-app';

          // expose the app, the router and the store.
          // note we are not mounting the app here, since bootstrapping will be
          // different depending on whether we are in a browser or on the server.
          return _context.abrupt("return", {
            app: app,
            store: store,
            router: router
          });
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ref.apply(this, arguments);
}